import CircularProgress from "@material-ui/core/CircularProgress"

export const ProgressCircular = ({title, loading}) =>{
    return loading ? <CircularProgress style={{'color': 'white'}} size={20}/> : title
}
